import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequestListPageComponent } from './request-list-page/request-list-page.component';
import { ResearchAuthGuard } from 'research.oidc.angular';
import { ViewRequestsResolver } from '../shared/resolvers/view-requests.resolver';
import { ReviewRequestPageComponent } from './review-request-page/review-request-page.component';
import { RequestReviewResolver } from './resolvers/request-review.resolver';
import { RequestBarcodeResolver } from './resolvers/request-barcode.resolver';
import { CurrentUserResolver } from '../shared/resolvers/current-user.resolver';
import { SeedRequestsResolver } from '../shared/resolvers/seed-requests-resolver';

const routes: Routes = [
  {
    path: 'requests/view/all',
    component: RequestListPageComponent,
    canActivate: [ResearchAuthGuard],
    resolve: {
      requestOptions: ViewRequestsResolver,
      currentUser: CurrentUserResolver
    }
  },
  {
    path: 'requests/view/:id',
    component: ReviewRequestPageComponent,
    canActivate: [ResearchAuthGuard],
    resolve: {
      request: RequestReviewResolver,
      requestBarcode: RequestBarcodeResolver,
      seedRequests: SeedRequestsResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewRequestRoutingModule { }



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/view-request-routing.module.ts